require('./lbModal.scss');

const $inject = ['$compile'];

const lbModal = function ($compile) {
  return {
    bindToController: true,
    controllerAs: 'vm',
    controller: 'lbModalCtrl',
    template: require('./lbModal.html'),
    scope: {
      width: '<?',
      className: '<?',
    },
    link: function (scope, ele, attrs) {
      scope.$watch('vm.modalContent', function (modalContent) {
        if (modalContent) {
          let contentEle = ele[0].querySelector('.lbModal_content');
          contentEle.innerHTML = modalContent;
          $compile(contentEle)(scope);
        }
      });
    },
  };
};

lbModal.$inject = $inject;

export default lbModal;



// WEBPACK FOOTER //
// ./src/components/lbModal/lbModalDir.js